import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Sketches",
  "description": "",
  "published": "2006-06-07T00:00:00.000Z",
  "redirect_from": ["/blog/sketches/swizec/408"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today there are some announcements to be made, nothing too grand, but nothing ungrand just the same. So let's to the beginning.`}</p>
    <ol>
      <li parentName="ol">{`Episode 2 of Cthulhu has had the script finalised and it should be finished and uploaded by the end of the week, if of course work and study won't suck up too large amounts of the much needed time to do so. Wanted to give you a sketch of a guest character, but you get nothing of the kind right now, sorry.`}</li>
      <li parentName="ol">{`A decision has been made by the board of directors for this site... heh that was a funny though... to start producing daily sketches and post them somewhere on the site, you get one sketch today and then sketches will soon begin daily with a thumbnail in one of the sidebars. Hopefully they will be entertaining and the one making them will have time to keep it up.`}</li>
    </ol>
    <p>{`On a final note, go check out `}<a parentName="p" {...{
        "href": "http://www.escapistmagazine.com/issue/48"
      }}>{`Blizzard's secret sauce.`}</a></p>
    <p><a parentName="p" {...{
        "href": "/includes/editor_upload/Image/sketches/kscan_0129.png"
      }}><img parentName="a" {...{
          "src": "/includes/editor_upload/Image/sketches/kscan_0129.png",
          "alt": null
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      